import store from '@/store'
import router from '@/router'

async function createRoutes() {
  // get user info
  // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
  const { username, menus } = await store.dispatch('user/getInfo')

  // generate accessible routes map based on roles
  const accessedRouters = await store.dispatch('permission/generateRoutes', { menus, username })

  // 动态添加可访问路由表
  router.addRoutes(accessedRouters)
}

export { createRoutes }
